if (!window.carouselHeroes) { // Only run once
  window.carouselHeroes = [];
  const itemClass = 'carousel-item';
  const wrapInSwiperSlide = (item) => {
    const slide = document.createElement('swiper-slide');
    slide.append(item);
    return slide;
  }
  const chevronUseSvg = (dir = 'left') => {
    return `<svg width="24" height="24" viewBox="0 0 24 24">
      <use href="#chevron-${dir}-use" />
    </svg>`;
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(`.${itemClass}`).forEach((carouselItem) => {
      // Return if not first in a row.
      if (carouselItem.previousElementSibling && carouselItem.previousElementSibling.classList.contains(itemClass)) return;

      // Create swiper.
      const swiper = document.createElement('swiper-container');

      // Important: Don't let swiper init until we've set config.
      Object.assign(swiper, { init: false });

      // Wrap it in a parent.
      const swiperParent = document.createElement('swiper-parent');
      ['relative','block'].forEach(c => swiperParent.classList.add(c));
      swiperParent.appendChild(swiper);

      // Insert before original.
      carouselItem.parentNode.insertBefore(swiperParent, carouselItem);

      /*
       * NOTE:
       * Had some trouble with this, as next
       * didn't work as a reference if we moved the
       * DOM element first.
       *
       * This is why I moved the next needle then
       * moved the original DOM element into the
       * swiper element.
       *
       * This also seemingly did not disturb Shopify's
       * section builder...which is dope.
       */
      // Needed for loop.
      let next = carouselItem.nextElementSibling;

      // Append first item.
      swiper.appendChild(wrapInSwiperSlide(carouselItem));


      // Loop through subsequent matching items, append.
      while (next && next.classList.contains(itemClass)) {
        const nextEl = next;
        next = next.nextElementSibling;
        swiper.appendChild(wrapInSwiperSlide(nextEl));
      }

      // Append nav if multiple slides exist.
      const hasControls = swiper.childElementCount > 1;
      const controls = document.createElement('div');

      if (hasControls) {
        controls.innerHTML = `<div class="absolute bottom-8 left-half -translate-x-half text-white flex items-center gap-4 z-[2] rounded-full bg-black bg-opacity-60 py-4 px-6">
          <a class="prev" href="#">
            ${chevronUseSvg()}
          </a>
          <span class="fraction min-w-10 text-center"></span>
          <a class="next" href="#">
            ${chevronUseSvg('right')}
          </a>
        </div>`;

        swiperParent.appendChild(controls);
      }

      // Swiper config
      const swiperParams = {
        loop: false,
        navigation: {
          clickable: true,
          disabledClass: "opacity-30 pointer-events-none",
          prevEl: swiperParent.querySelector(`.prev`),
          nextEl: swiperParent.querySelector(`.next`),
        },
        pagination: {
          el: swiperParent.querySelector('.fraction'),
          type: "fraction",
        },
      };

      Object.assign(swiper, swiperParams);
      swiper.initialize();

      window.carouselHeroes.push(swiper);
    });
  });
}
